module.exports = __webpack_public_path__ + "img/police_car.45a8ac85.png";